import { Box, IconButton, Popover, PopoverArrow, PopoverBody, PopoverCloseButton, PopoverContent, PopoverTrigger, Text } from "@chakra-ui/react";
import { FiInfo } from "react-icons/fi";
import { VerAgendamentoButton } from "../../carga/components";
import { TransbordoItem } from "../types";

interface IProps {
  item: TransbordoItem;
}

const StatusAgendamentoTransbordo = ({ item }: IProps) => {
  if (item.j81_ukey || item.cliente_necessita_agendamento != 1) {
    return null;
  }

  if (item.pedido_status_agendamento == "1") {
    return (
      <VerAgendamentoButton
        j14_ukey={item.j14_ukey}
        j07_ukey={item.j07_ukey}
        pedido_numero={item.pedido_numero}
        pedido_status_agendamento={item.pedido_status_agendamento}
        texto="AGENDADO"
      />
    );
  }

  return (
    <Box color="blue.600" fontSize="0.9rem" fontWeight="semibold" textAlign="right">
      {item.pedido_agendamento_futuro == 1 && <Text>Agendamento futuro</Text>}
      <Text display="flex" alignItems="center" justifyContent="flex-end">
        Agendamento pendente
        <Popover placement="left">
          <PopoverTrigger>
            <IconButton aria-label="Informação do agendamento" icon={<FiInfo />} size="xs" variant="ghost" colorScheme="blue" ml={1} />
          </PopoverTrigger>
          <PopoverContent>
            <PopoverArrow />
            <PopoverCloseButton />
            <PopoverBody fontWeight="normal" color="gray.700">
              Este agendamento está pendente, solicite ao Moinho Globo para realizar o agendamento junto ao cliente.
            </PopoverBody>
          </PopoverContent>
        </Popover>
      </Text>
    </Box>
  );
};

export default StatusAgendamentoTransbordo;
